import React, { FC, PropsWithChildren, useEffect, useState } from "react"
import { collection, FirestoreError, getDocs } from "firebase/firestore"

import { AuthenticationContext, User } from "./index"
import { firebase } from "../../services/firebase/firebase"
import { useCookies } from "react-cookie"

interface CookieValues {
    organisation?: string;
}

export const AuthenticationProvider: FC<PropsWithChildren> = ({ children }) => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<FirestoreError>()
    const [cookies, setCookie] = useCookies<"organisation", CookieValues>(["organisation"])
    const [user, setUser] = useState<User|null>()

    const setOrganisation = (organisation: string) => {
        if (user) {
            setCookie("organisation", organisation)
            setUser({ ...user, organisation })
        }
    }

    const hasRole = (role: string | "admin") => {
        if (user?.isSuper || user?.roles === true) { return true }
        return user?.roles?.includes(role) ?? false
    }

    useEffect(
        () =>
            firebase.auth.onAuthStateChanged(async user => {
                if (user) {
                    setLoading(true)
                    setError(undefined)

                    const claims = await user
                        .getIdTokenResult(true)
                        .then(result => result.claims)
                        .catch(setError)
                    if (!claims) return

                    let organisation: string = claims.organisation as string
                    if (claims.organisation === true) {
                         organisation = cookies.organisation ?? "Testing"
                    }

                    setUser({
                        ...user,
                        organisation,
                        groups: claims.groups as string[] | true,
                        isSuper: claims.organisation === true,
                        roles: claims.roles as string[] | true,
                    })
                    setLoading(false)
                } else setUser(null)
            }),
        [],
    )

    return (
        <AuthenticationContext.Provider
            value={{ user: user ?? null, isAuth: user === undefined ? null : !!user, setOrganisation, hasRole, loading, error }}
        >
            {children}
        </AuthenticationContext.Provider>
    )
}
